<template>
  <div id="app" :style="{minWidth: minWidth + 'px'}">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      minWidth: 1200
    }
  },
  mounted () {
    let userAgentInfo = navigator.userAgent
    let Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod")
    for (let i = 0; i < Agents.length; i++) {
      if (userAgentInfo.indexOf(Agents[i]) > 0) {
        this.minWidth = 0
        break
      }
    }
	document.title = this.$i18n.t('publictitle')
  }
}
</script>

<style>
#app {
  min-width: 11.667rem;
  overflow: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 0;
  overflow: hidden;
}
.btn_blue_boder{
	border: #57AEC9 1px solid;
	color: #57AEC9;
}
.btn_gray{
	background-color: #666666;
	color: #ffffff;
}
.btn_gray_boder{
	border: #cccccc 1px solid;
	color: #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/App.vue